module.exports = __webpack_public_path__ + "img/link_u1.3a2ff901.png";